import { cn } from '../../lib/cn';
import { Signal, Wifi, Battery } from 'lucide-react';

interface StatusBarProps {
  variant?: 'android' | 'iphone';
}

export function StatusBar({ variant = 'android' }: StatusBarProps) {
  const isDark = true;

  return (
    <div
      className={cn(
        'relative flex h-6 w-full items-center justify-between px-4 text-xs font-medium select-none',
        isDark ? 'bg-slate-950 text-white' : 'bg-white text-slate-900'
      )}
    >
      {variant === 'iphone' && (
        <div className="absolute left-1/2 top-0 h-5 w-24 -translate-x-1/2 rounded-b-xl bg-black" />
      )}

      <div className="flex items-center gap-1">
        <span>9:41</span>
      </div>

      <div className="flex items-center gap-1">
        <Signal className="h-3 w-3" />
        <Wifi className="h-3 w-3" />
        <Battery className="h-3 w-3" />
      </div>
    </div>
  );
}
